import Modal from "./Modal";

type Props = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  title: string;
  description?: string;
  confirmLabel?: string;
  cancelLabel?: string;
  variant?: "default" | "danger";
  onConfirm: () => void | Promise<void>;
};

export default function ConfirmDialog({
  open,
  onOpenChange,
  title,
  description,
  confirmLabel = "Confirmar",
  cancelLabel = "Cancelar",
  variant = "default",
  onConfirm,
}: Props) {
  const confirmCls =
    variant === "danger"
      ? "btn bg-red-600 hover:bg-red-500 text-white"
      : "btn-primary";

  async function handleConfirm() {
    await onConfirm();
    onOpenChange(false);
  }

  return (
    <Modal
      open={open}
      onOpenChange={onOpenChange}
      title={title}
      description={description}
      size="sm"
      footer={
        <>
          <button onClick={() => onOpenChange(false)} className="btn-ghost">
            {cancelLabel}
          </button>
          <button onClick={handleConfirm} className={confirmCls}>
            {confirmLabel}
          </button>
        </>
      }
    >
      <span className="sr-only">{description ?? title}</span>
    </Modal>
  );
}
